import { PUBLIC_ENV } from 'utils/publicEnv';

export const useFeatureFlags = () => ({
    isGuestCheckoutEnabled: PUBLIC_ENV.NEXT_PUBLIC_GUEST_CHECKOUT_ENABLED,
    isOmnibusEnabled: PUBLIC_ENV.NEXT_PUBLIC_OMNIBUS_ENABLED,
});
